/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_TeamInputs */

const th_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทีมที่สังกัด`)
};

const en_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squad`)
};

const ja_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所属チーム`)
};

const zh_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`阵容`)
};

const es_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantilla`)
};

const pt_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco`)
};

const id_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad`)
};

const fr_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effectif`)
};

const tl_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squad`)
};

const vi_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đội hình`)
};

const ko_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수단`)
};

const de_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kader`)
};

const ru_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Состав`)
};

const tr_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kadro`)
};

const it_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosa`)
};

const pl_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skład`)
};

const uk_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Склад`)
};

const hi_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम`)
};

const ar_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التشكيلة`)
};

const ms_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuad`)
};

const bn_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল`)
};

const zh_tw2_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單`)
};

const zh_hk2_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名單`)
};

const ur_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسکواڈ`)
};

const fa_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهرست تیم`)
};

const sw_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kikosi`)
};

const nl_player_team = /** @type {(inputs: Player_TeamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectie`)
};

/**
* | output |
* | --- |
* | "Squad" |
*
* @param {Player_TeamInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_team = /** @type {((inputs?: Player_TeamInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_TeamInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_team(inputs)
	if (locale === "ja") return ja_player_team(inputs)
	if (locale === "zh") return zh_player_team(inputs)
	if (locale === "es") return es_player_team(inputs)
	if (locale === "pt") return pt_player_team(inputs)
	if (locale === "id") return id_player_team(inputs)
	if (locale === "fr") return fr_player_team(inputs)
	if (locale === "tl") return tl_player_team(inputs)
	if (locale === "vi") return vi_player_team(inputs)
	if (locale === "ko") return ko_player_team(inputs)
	if (locale === "de") return de_player_team(inputs)
	if (locale === "ru") return ru_player_team(inputs)
	if (locale === "tr") return tr_player_team(inputs)
	if (locale === "it") return it_player_team(inputs)
	if (locale === "pl") return pl_player_team(inputs)
	if (locale === "uk") return uk_player_team(inputs)
	if (locale === "hi") return hi_player_team(inputs)
	if (locale === "ar") return ar_player_team(inputs)
	if (locale === "ms") return ms_player_team(inputs)
	if (locale === "bn") return bn_player_team(inputs)
	if (locale === "zh-TW") return zh_tw2_player_team(inputs)
	if (locale === "zh-HK") return zh_hk2_player_team(inputs)
	if (locale === "ur") return ur_player_team(inputs)
	if (locale === "fa") return fa_player_team(inputs)
	if (locale === "sw") return sw_player_team(inputs)
	if (locale === "nl") return nl_player_team(inputs)
	return en_player_team(inputs)
});